export const numberToDateString = (param) => {
    const bulan = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]

    const fullDate2 = new Date(param)
    const monthName = bulan[fullDate2.getMonth()]

    let fullDate = `${new Date(param).toUTCString()}`

    let date = `${new Date(fullDate).getDate()}`
    // let month = `${new Date(fullDate).getMonth() + 1}`
    let fullYear = `${new Date(fullDate).getFullYear()}`

    if (date.length < 2) date = `0${date}`
    // if (month.length < 2) month = `0${month}`

    // 06 Juni 2023
    return `${date} ${monthName} ${fullYear}`
}